import { css } from "@emotion/css";

import type { FC } from "react";

const styles = {
  appContainer: css`
    height: 100vh;
  `,
};

const EmbededAppContainer: FC = ({ children }) => (
  <div className={styles.appContainer}>{children}</div>
);

export default EmbededAppContainer;
